import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ShLabelComponent } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { StatusCell } from './status-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-status-cell',
    templateUrl: './status-cell.component.html',
    imports: [CommonModule, ShLabelComponent]
})
export class ShStatusCellComponent extends ShBaseCell {
    @Input() public cell!: StatusCell;
}
